var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',{staticClass:"kanban-column-loading h-100 rounded mr-2",attrs:{"width":300,"height":_vm.height}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"2","ry":"2","width":"300","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }